<template>
  <div>
    <v-card class="blue lighten-4" style="width: 100vw; height: 100vh">
      <v-app-bar class="rounded-b-lg" floating fixed style="background-color: #def6f4; z-index: 55;" >
        <v-app-bar-nav-icon @click="$store.commit('setExploreViewVisibility', false)"><v-icon>mdi-close</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Explore</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <div style="top: 7vh; position: absolute; width: 100vw; height: 93vh" class="blue lighten-4 px-3">
        <v-text-field label="Looking For Something?" v-model="searchTerm" class="mt-3"></v-text-field>
        <v-list class="blue lighten-4" width="100vw" style="position: absolute; left: 0">
          <v-list-item v-for="item in filteredSearchTerms" :key="item.id" class="blue lighten-4" @click="openItemDialog(item.type, item.id)">
            <v-list-item-icon v-if="item.type === 'location'"><v-icon>mdi-map-marker</v-icon></v-list-item-icon>
            <v-list-item-icon v-else-if="item.type === 'social'"><v-icon>mdi-star</v-icon></v-list-item-icon>
            <v-list-item-icon v-else><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-avatar>
              <v-list-item-avatar>
                <v-img v-if="item.type === 'user'" :src="item.pic_url || require('@/assets/profile_placeholder.png')" lazy-src="~@/assets/profile_placeholder.png"></v-img>
                <v-img v-else :src="item.pic_url || require('@/assets/alberta-2297204_1920.jpg')" lazy-src="~@/assets/alberta-2297204_1920.jpg"></v-img>
              </v-list-item-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title style="text-transform: capitalize; white-space: pre-wrap">{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-card>
<!--    <div style="margin-left: 5vw; margin-right: 5vw;">-->
<!--      <v-text-field label="Looking For Something?" v-model="searchTerm"></v-text-field>-->
<!--      <v-list class="blue lighten-4">-->
<!--        <v-list-item v-for="item in filteredSearchTerms" :key="item.id" class="blue lighten-4" @click="openItemDialog(item.type, item.id)">-->
<!--          <v-list-item-icon v-if="item.type === 'location'"><v-icon>mdi-map-marker</v-icon></v-list-item-icon>-->
<!--          <v-list-item-icon v-else-if="item.type === 'social'"><v-icon>mdi-star</v-icon></v-list-item-icon>-->
<!--          <v-list-item-icon v-else><v-icon>mdi-account</v-icon></v-list-item-icon>-->
<!--          <v-list-item-avatar>-->
<!--            <v-list-item-avatar>-->
<!--              <v-img v-if="item.type === 'user'" :src="item.pic_url || require('@/assets/profile_placeholder.png')" lazy-src="~@/assets/profile_placeholder.png"></v-img>-->
<!--              <v-img v-else :src="item.pic_url || require('@/assets/alberta-2297204_1920.jpg')" lazy-src="~@/assets/alberta-2297204_1920.jpg"></v-img>-->
<!--            </v-list-item-avatar>-->
<!--          </v-list-item-avatar>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title style="text-transform: capitalize; white-space: pre-wrap">{{ item.name }}</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
<!--      </v-list>-->
<!--    </div>-->
    <SocialEventDialog></SocialEventDialog>
  </div>

</template>

<script>

import {store} from "@/store";
import SocialEventDialog from "@/components/SocialEventDialog.vue";

export default {
  name: 'GlobalSearch',
  components: {SocialEventDialog},
  data() {
    return {
      searchTerms: [],
      searchTerm: '',
    };
  },
  computed: {
    filteredSearchTerms() {
      // Computed property for the filtered list
      return this.$store.state.searchTerms.filter(term => {
        return term.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    },
  },
  methods: {
    async openItemDialog(itemType, itemId) {
      if (itemType === 'location') {
        let tempLocationData = {}
        tempLocationData = store.state.topLocations.find(location => location.id === itemId);
        await store.dispatch('openTopLocationDialog', tempLocationData)
      } else if (itemType === 'user') {
        await store.dispatch('getProfileCardData', itemId)
        store.commit('profileDialogOn')
      } else if (itemType === 'social') {
        let itemData = store.state.socialData.find(contribution => contribution.id === itemId);
        console.log(itemData)
        store.commit('setSocialEvent', itemData)
      }
    }
  },
  async mounted() {
    await store.dispatch('getUsers')
    store.commit('getSearchTerms')
  },
};
</script>

<style scoped>

</style>
